import EnumService from '../EnumService'

export default class BancoEnumService extends EnumService{

    constructor(){
        super('enumBanco');
    }
  
  }